export interface IKeyword {
  _id?: string;
  title: string;
  density?: boolean;
  createdAt?: Date;
}

export enum KEYWORD_PRIORITY_ENUM {
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  HIGH = 'HIGH',
  STRATEGIC = 'STRATEGIC',
}

export const KEYWORD_COLORS = {
  [KEYWORD_PRIORITY_ENUM.STRATEGIC]: '#72B62F',
  [KEYWORD_PRIORITY_ENUM.HIGH]: '#254EDB',
  [KEYWORD_PRIORITY_ENUM.MEDIUM]: '#E89000',
  [KEYWORD_PRIORITY_ENUM.LOW]: '#E91C14',
};
